import React, { useEffect } from 'react';

import { useAppSelector } from '../../../../../store';
import { ModerationTable } from '../components/ModerationTable';
import { useLazyGetModerationQuery } from '../service/moderation.api';
import { selectAnalyticsFilters } from '../../../store/analyticFiltersSlice';

export const ModerationContainer = () => {
    const filters = useAppSelector(selectAnalyticsFilters);

    const [
        getModeration,
        {
            data: moderation = {
                members: [],
            },
        },
    ] = useLazyGetModerationQuery();

    useEffect(() => {
        if (filters) {
            const payload = {
                ...filters,
                community_id: filters.chat || null,
            };

            getModeration(payload, true);
        }
    }, [filters]);

    return <ModerationTable source={moderation.members} />;
};
